import { isBrowserOnline } from '../../../hooks/useOnlineStatus';

/**
 * Detects failures from React.lazy / dynamic import when a JS chunk cannot be loaded
 * (network offline, stale deploy, CDN error, etc.).
 */
export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;

  if (typeof error === 'string') {
    const text = error.toLowerCase();
    return text.includes('loading chunk') || text.includes('network error');
  }

  if (typeof error !== 'object') return false;

  const err = error as { name?: string; message?: string };
  const name = err.name ?? '';
  const message = (err.message ?? '').toLowerCase();

  if (name === 'ChunkLoadError') return true;

  const isImportNetworkFailure =
    message.includes('loading chunk') ||
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('importing a module script failed') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('dynamically imported module') ||
    message.includes('load failed') ||
    message === 'network error' ||
    message.includes('network error') ||
    message.includes('failed to fetch') ||
    message.includes('err_internet_disconnected') ||
    message.includes('internet_disconnected');

  if (isImportNetworkFailure) return true;

  // Offline: treat dynamic import failures as chunk errors (avoid raw "Network Error" UI).
  if (!isBrowserOnline() && (name === 'TypeError' || message.includes('fetch'))) {
    return true;
  }

  return false;
}
